import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "../components/ui/sheet";

const TABLES = {
    tops: {
        title: "Tops · Knitwear · Outerwear",
        cols: ["Size", "Chest (cm)", "Waist (cm)", "Length (cm)"],
        rows: [
            ["XS", "92", "78", "66"],
            ["S", "98", "82", "68"],
            ["M", "104", "86", "70"],
            ["L", "110", "92", "72"],
            ["XL", "118", "100", "74"],
        ],
    },
    denim: {
        title: "Denim · Trousers",
        cols: ["Waist (in)", "Waist (cm)", "Hip (cm)", "Inseam (cm)"],
        rows: [
            ["28", "71", "92", "78"],
            ["30", "76", "97", "80"],
            ["32", "81", "102", "82"],
            ["34", "86", "107", "84"],
            ["36", "91", "112", "84"],
        ],
    },
    footwear: {
        title: "Footwear · EU / US / UK",
        cols: ["EU", "US (M)", "UK", "Foot (cm)"],
        rows: [
            ["40", "7", "6", "25"],
            ["41", "8", "7", "26"],
            ["42", "9", "8", "27"],
            ["43", "10", "9", "27.5"],
            ["44", "11", "10", "28"],
            ["45", "12", "11", "29"],
        ],
    },
};

const CATEGORY_TO_TABLE = {
    tees: "tops",
    knitwear: "tops",
    outerwear: "tops",
    denim: "denim",
    footwear: "footwear",
};

export const SizeGuideDrawer = ({ open, onOpenChange, category }) => {
    const tableKey = CATEGORY_TO_TABLE[category];
    const table = tableKey ? TABLES[tableKey] : null;

    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetContent
                side="right"
                data-testid="size-guide-drawer"
                className="w-full sm:max-w-md bg-[#0C0C0C] border-l border-white/10 text-[#F4F4F0] p-0 rounded-none"
            >
                <SheetHeader className="px-6 pt-6 pb-4 border-b border-white/10">
                    <SheetTitle className="text-display text-3xl text-left">Size Guide</SheetTitle>
                    <SheetDescription className="text-[#A3A3A3] text-left">
                        Measurements in cm unless stated. Garment measurements — for body, subtract 4–6cm.
                    </SheetDescription>
                </SheetHeader>

                <div className="px-6 py-6 space-y-8">
                    {table ? (
                        <div className="space-y-4">
                            <div className="text-overline text-[#A3A3A3]">{table.title}</div>
                            <table className="w-full text-sm">
                                <thead>
                                    <tr className="border-b border-white/15 text-[#A3A3A3]">
                                        {table.cols.map((c) => (
                                            <th key={c} className="text-left py-2 text-[10px] tracking-[0.18em] uppercase font-display font-normal">{c}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {table.rows.map((row) => (
                                        <tr key={row[0]} className="border-b border-white/[0.06]">
                                            {row.map((cell, i) => (
                                                <td key={`${row[0]}-${table.cols[i]}`} className={`py-3 ${i === 0 ? "text-brutal text-sm" : "text-[#D6D6CC]"}`}>{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="text-[#A3A3A3]">One size. Designed to fit most.</p>
                    )}

                    <div className="border border-white/10 p-5 space-y-2">
                        <div className="text-overline text-[#A3A3A3]">How to measure</div>
                        <ul className="text-sm text-[#D6D6CC] space-y-1.5 leading-relaxed list-disc list-inside marker:text-[#591C1C]">
                            <li>Chest — widest point, under the arms.</li>
                            <li>Waist — narrowest point, above the navel.</li>
                            <li>Inseam — from crotch to ankle bone.</li>
                            <li>When between sizes, size up for our oversized cuts.</li>
                        </ul>
                    </div>
                </div>
            </SheetContent>
        </Sheet>
    );
};
